"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
exports.default = (function (acceptanceData, projectTotal) {
    var e_1, _a;
    var totals = projectTotal.calculateProject();
    var projectCurrencies = Object.keys(totals);
    var totalsList = [];
    try {
        for (var projectCurrencies_1 = __values(projectCurrencies), projectCurrencies_1_1 = projectCurrencies_1.next(); !projectCurrencies_1_1.done; projectCurrencies_1_1 = projectCurrencies_1.next()) {
            var currencyCode = projectCurrencies_1_1.value;
            var calculatedProject = totals[currencyCode];
            var preTax = calculatedProject.preTax, postTax = calculatedProject.postTax;
            var totalEntry = {
                currency: currencyCode,
                acceptedTotal: preTax,
                acceptedTotalWithTaxes: postTax,
                recurringTotals: convertRecurringTotalsToAcceptedRecurringTotals(calculatedProject),
                oneOffTotals: {
                    total: calculatedProject.oneOffTotals.preTax,
                    totalWithTaxes: calculatedProject.oneOffTotals.postTax,
                },
            };
            totalsList.push(totalEntry);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (projectCurrencies_1_1 && !projectCurrencies_1_1.done && (_a = projectCurrencies_1.return)) _a.call(projectCurrencies_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    if (projectCurrencies.length === 1) {
        var firstCurrency = projectCurrencies[0];
        var calculatedProject = totals[firstCurrency];
        var preTax = calculatedProject.preTax, postTax = calculatedProject.postTax;
        acceptanceData.currency = firstCurrency;
        acceptanceData.acceptedTotal = preTax;
        acceptanceData.acceptedTotalWithTaxes = postTax;
        acceptanceData.recurringTotals = convertRecurringTotalsToAcceptedRecurringTotals(calculatedProject);
        acceptanceData.oneOffTotals = {
            total: calculatedProject.oneOffTotals.preTax,
            totalWithTaxes: calculatedProject.oneOffTotals.postTax,
        };
    }
    acceptanceData.acceptedTotals = totalsList;
});
var convertRecurringTotalsToAcceptedRecurringTotals = function (total) {
    var e_2, _a;
    var recurringTotals = total.recurringTotals;
    var acceptedRecurringTotals = [];
    try {
        for (var _b = __values(lodash_1.default.entries(recurringTotals)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = __read(_c.value, 2), key = _d[0], value = _d[1];
            if (!!value) {
                acceptedRecurringTotals.push({
                    frequency: key,
                    total: value.preTax,
                    totalWithTaxes: value.postTax,
                });
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return acceptedRecurringTotals;
};
